<template>
  <div class="neo-pharma-home">
    <!-- 顶部导航组件 -->
    <TheHeader />

    <!-- 全新流体英雄区域 -->
    <section class="fluid-hero-section">
      <!-- 动态背景粒子 -->
      <div class="particle-background">
        <div v-for="n in 50" :key="n" class="particle" :style="getParticleStyle(n)"></div>
      </div>

      <!-- 流体形状背景 -->
      <div class="fluid-shapes">
        <div class="fluid-shape shape-1"></div>
        <div class="fluid-shape shape-2"></div>
        <div class="fluid-shape shape-3"></div>
      </div>

      <!-- 主要内容区域 -->
      <div class="hero-content-wrapper">
      <!-- 加载中状态 -->
        <div v-if="bannerLoading" class="neo-loading-state">
          <div class="loading-orb">
            <div class="orb-ring"></div>
            <div class="orb-core">
        <el-icon class="loading-icon"><Loading /></el-icon>
            </div>
          </div>
          <p class="loading-text">正在加载精彩内容...</p>
      </div>

        <!-- 错误状态 -->
        <div v-else-if="bannerError" class="neo-error-state">
          <div class="error-icon-wrapper">
            <el-icon class="error-icon"><WarningFilled /></el-icon>
          </div>
          <p class="error-text">内容加载失败，请稍后重试</p>
          <button class="retry-btn" @click="loadBannerData">重新加载</button>
      </div>

        <!-- 轮播内容 -->
        <div v-else class="neo-carousel-container">
          <!-- 当前展示的轮播项 -->
          <div class="carousel-display">
            <div
              v-for="(banner, index) in bannerList"
              :key="banner.id"
              class="carousel-slide"
              :class="{
                'slide-active': index === currentSlide,
                'slide-next': index === getNextSlideIndex(),
                'slide-prev': index === getPrevSlideIndex()
              }"
            >
              <!-- 图片容器 -->
              <div class="slide-image-container">
                <div class="image-frame">
                <img :src="banner.image_url" :alt="banner.title" />
                </div>
                <div class="image-overlay"></div>
              </div>

              <!-- 内容区域 -->
              <div class="slide-content">
                <div class="content-badge">NEW</div>
                <h1 class="slide-title">
                  {{ banner.title || '全新药品体验' }}
                </h1>
                <p class="slide-description">
                  {{ banner.description || '专业品质，值得信赖的健康守护者' }}
                </p>
                <div class="slide-actions">
                  <router-link :to="{ name: 'Products' }" class="neo-btn neo-btn-primary">
                    <span>探索产品</span>
                    <div class="btn-glow"></div>
                    </router-link>
                  <button class="neo-btn neo-btn-ghost">
                    <span>了解更多</span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- 导航控件 -->
          <div class="carousel-controls">
            <button class="control-btn prev-btn" @click="prevSlide">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
            <button class="control-btn next-btn" @click="nextSlide">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
          </div>

          <!-- 指示器 -->
          <div class="carousel-indicators">
            <div
              v-for="(banner, index) in bannerList"
              :key="banner.id"
              class="indicator"
              :class="{ active: index === currentSlide }"
              @click="goToSlide(index)"
            >
              <div class="indicator-progress"></div>
          </div>
        </div>
      </div>
      </div>
    </section>

    <!-- 全新药品展示区域 -->
    <section class="neo-medicine-showcase">
      <!-- 背景装饰 -->
      <div class="showcase-bg">
        <div class="bg-grid"></div>
        <div class="bg-orbs">
          <div class="orb orb-1"></div>
          <div class="orb orb-2"></div>
          <div class="orb orb-3"></div>
        </div>
    </div>

      <div class="showcase-container">
        <!-- 区域标题 -->
      <div class="showcase-header">
          <div class="header-wrapper">
            <div class="title-section">
              <div class="title-badge">
                <span>FEATURED</span>
                <div class="badge-glow"></div>
          </div>
              <h2 class="section-title">
                精选药品
                <span class="title-accent">推荐</span>
              </h2>
              <p class="section-subtitle">专业品质 · 科技守护您的健康</p>
            </div>
            <router-link :to="{ name: 'Products' }" class="view-all-link">
              <span>查看全部产品</span>
              <div class="link-arrow">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M7 17L17 7M17 7H7M17 7V17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
              </div>
          </router-link>
        </div>
      </div>

        <!-- 内容区域 -->
        <div class="showcase-content">
      <!-- 加载状态 -->
          <div v-if="medicineLoading" class="neo-loading-state">
            <div class="loading-spinner">
              <div class="spinner-ring"></div>
              <div class="spinner-dot"></div>
            </div>
            <p class="loading-text">正在加载精选产品...</p>
      </div>

          <!-- 错误状态 -->
          <div v-else-if="medicineError" class="neo-error-state">
            <div class="error-visual">
              <div class="error-circle">
        <el-icon class="error-icon"><WarningFilled /></el-icon>
              </div>
            </div>
            <p class="error-message">{{ medicineError }}</p>
            <button class="neo-retry-btn" @click="loadMedicineData">
              <span>重新加载</span>
              <div class="btn-ripple"></div>
            </button>
      </div>

          <!-- 无数据状态 -->
          <div v-else-if="medicineList.length === 0" class="neo-empty-state">
            <div class="empty-visual">
              <div class="empty-icon"></div>
            </div>
            <p class="empty-message">暂无药品数据</p>
      </div>

          <!-- 药品网格 -->
          <div v-else class="medicine-grid">
            <div
              v-for="(product, index) in medicineList.slice(0, 6)"
              :key="product.id"
              class="medicine-card"
              :style="{ '--delay': index * 0.1 + 's' }"
            >
              <!-- 卡片背景效果 -->
              <div class="card-bg">
                <div class="card-shine"></div>
                <div class="card-gradient"></div>
              </div>

              <!-- 图片区域 -->
              <div class="card-image-wrapper">
                <div class="image-container">
            <img :src="getFullImageUrl(product.image) || placeholderImages.med1" :alt="product.name" />
                  <div class="image-glow"></div>
                </div>
            <div class="image-overlay">
                  <router-link :to="{ name: 'ProductDetail', params: { id: product.id } }" class="quick-action-btn">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M1 12C1 12 5 4 12 4S23 12 23 12S19 20 12 20S1 12 1 12Z" stroke="currentColor" stroke-width="2"/>
                      <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="2"/>
                </svg>
              </router-link>
            </div>
                <!-- 分类标签 -->
                <div class="category-tag">
                  {{ product.category ? product.category.name : '医药产品' }}
          </div>
            </div>

              <!-- 内容区域 -->
              <div class="card-content">
                <h3 class="product-name">{{ product.name }}</h3>

                <div class="product-meta">
                  <div v-if="product.manufacturer" class="meta-item">
                    <div class="meta-icon">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                        <path d="M3 21H21M5 21V7L13 3L21 7V21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
              </div>
                    <div class="meta-content">
                      <span class="meta-label">厂家</span>
                      <span class="meta-value">{{ getShortManufacturer(product.manufacturer) }}</span>
              </div>
              </div>

                  <div v-if="product.approval_number" class="meta-item">
                    <div class="meta-icon">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                        <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
            </div>
                    <div class="meta-content">
                      <span class="meta-label">文号</span>
                      <span class="meta-value">{{ product.approval_number }}</span>
                    </div>
                  </div>
                </div>

                <div v-if="product.description || product.indications" class="product-description">
                  {{ getShortDescription(product.description) || (product.indications ? getShortIndications(product.indications) : '暂无描述') }}
                </div>

                <div class="card-actions">
                  <router-link :to="{ name: 'ProductDetail', params: { id: product.id } }" class="action-btn">
                    <span>了解详情</span>
                    <div class="btn-bg"></div>
              </router-link>
            </div>
          </div>
        </div>
      </div>

          <!-- 分页控件 -->
          <div v-if="medicinePagination.total > 0" class="neo-pagination">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="medicinePagination.total"
          :page-size="medicinePagination.pageSize"
          :current-page="medicinePagination.currentPage"
          @current-change="handleCurrentChange"
        />
          </div>
        </div>
      </div>
    </section>

    <!-- 全新关于我们区域 -->
    <section class="neo-about-section">
      <!-- 背景装饰层 -->
      <div class="about-bg-layers">
        <div class="layer layer-1"></div>
        <div class="layer layer-2"></div>
        <div class="layer layer-3"></div>
      </div>

      <div class="about-container">
        <!-- 加载状态 -->
        <div v-if="aboutUsLoading" class="neo-loading-state">
          <div class="pulse-loader">
            <div class="pulse-ring"></div>
            <div class="pulse-core">
          <el-icon class="loading-icon"><Loading /></el-icon>
            </div>
          </div>
          <p class="loading-text">正在加载企业信息...</p>
        </div>

        <!-- 错误状态 -->
        <div v-else-if="aboutUsError" class="neo-error-state">
          <div class="error-wrapper">
            <div class="error-glow">
          <el-icon class="error-icon"><WarningFilled /></el-icon>
            </div>
            <p class="error-text">{{ aboutUsError }}</p>
            <button class="neo-retry-btn" @click="loadAboutUsData">
              <span>重新加载</span>
              <div class="btn-wave"></div>
            </button>
          </div>
        </div>

        <!-- 主要内容 -->
        <div v-else class="about-content-wrapper">
          <!-- 内容网格 -->
          <div class="about-grid">
            <!-- 主要信息卡片 -->
            <div class="main-info-card">
              <div class="card-glow-bg"></div>

              <div class="info-header">
                <div class="company-badge">
                  <span class="badge-text">ABOUT US</span>
                  <div class="badge-particles">
                    <div v-for="i in 6" :key="i" class="particle"></div>
              </div>
                </div>
                <h2 class="company-title">
                  {{ aboutUsData.title || '专业医药' }}
                  <span class="title-highlight">科技先锋</span>
                </h2>
                <p class="company-tagline">
                  致力于为全球用户提供优质的医药产品和专业的健康解决方案
                </p>
            </div>

              <div class="info-content">
                <div class="description-wrapper">
                  <div v-if="aboutUsData.content" v-html="sanitizeHtml(aboutUsData.content)" class="company-description"></div>
                  <div v-else class="company-description">
                    <p>我们是一家专注于医药健康领域的创新型企业，致力于通过科技创新为用户提供更安全、更有效的医药产品。</p>
                    <p>凭借专业的研发团队和严格的质量管理体系，我们的产品覆盖多个治疗领域，深受医疗机构和患者的信赖。</p>
                  </div>
                </div>
                <div class="qualification">
                  <div v-for="(item, index) in qualificationList" :key="item" class="qualification-item">
                    <el-image
                        :src="item"
                        :preview-src-list="qualificationList"
                        :initial-index="index"
                        fit="cover"
                        :z-index="999999"
                        :preview-teleported="true"
                    ></el-image>
                  </div>
                </div>
                <div class="cta-section">
                  <router-link :to="{ name: 'About' }" class="neo-cta-btn">
                    <span class="btn-text">了解更多</span>
                    <div class="btn-icon">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                        <path d="M7 17L17 7M17 7H7M17 7V17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                </div>
                    <div class="btn-glow"></div>
                  </router-link>
                </div>
                </div>
              </div>


            <!-- 核心价值卡片 -->
            <div class="values-section">
              <h3 class="values-title">核心价值</h3>
              <div class="values-grid">
                <div class="value-item">
                  <div class="value-bg"></div>
                  <div class="value-icon-wrapper">
                  <div class="value-icon">
                      <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                        <path d="M9 12L11 14L15 10M21 12C21 16.97 16.97 21 12 21C7.03 21 3 16.97 3 12C3 7.03 7.03 3 12 3C16.97 3 21 7.03 21 12Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </div>
                </div>
                  <h4 class="value-name">专业品质</h4>
                  <p class="value-desc">严格的质量控制体系确保每一个产品都达到最高标准</p>
                </div>

                <div class="value-item">
                  <div class="value-bg"></div>
                  <div class="value-icon-wrapper">
                  <div class="value-icon">
                      <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                        <path d="M12 2L2 7V10C2 16 6 20.88 12 22C18 20.88 22 16 22 10V7L12 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </div>
                </div>
                  <h4 class="value-name">安全可靠</h4>
                  <p class="value-desc">通过多项权威认证，确保产品安全性和可靠性</p>
                </div>

                <div class="value-item">
                  <div class="value-bg"></div>
                  <div class="value-icon-wrapper">
                  <div class="value-icon">
                      <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                        <path d="M20.84 4.61C19.32 6.04 15.95 6.04 12 9.5C8.05 6.04 4.68 6.04 3.16 4.61C1.64 3.18 3.25 1.47 4.75 2.34C6.25 3.21 8.51 3.21 12 6.5C15.49 3.21 17.75 3.21 19.25 2.34C20.75 1.47 22.36 3.18 20.84 4.61Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </div>
                </div>
                  <h4 class="value-name">贴心服务</h4>
                  <p class="value-desc">提供全方位的客户支持和专业的健康咨询服务</p>
              </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 底部信息组件 -->
    <TheFooter />
  </div>
</template>

<script>
// 导入Element Plus组件
import { ElIcon, ElPagination} from 'element-plus'
import { Loading, WarningFilled } from '@element-plus/icons-vue'
import 'element-plus/dist/index.css'
// 导入占位图片
import { placeholderImages } from '@/assets/placeholder.js'
// 导入自定义组件
import TheHeader from './TheHeader.vue'
import TheFooter from './TheFooter.vue'
// 导入API
import { getBanners } from '@/api/bannerService'
// 导入药品和公司简介服务
import { getMedicines, getAboutUs, BASE_URL } from '@/api/config'

export default {
  name: 'HelloWorld',
  components: {
    ElIcon,
    ElPagination,
    Loading,
    WarningFilled,
    TheHeader,
    TheFooter
  },
  data() {
    return {
      // 图片资源
      images: placeholderImages,
      // 轮播图数据（从API获取）
      bannerList: [],
      bannerLoading: true,
      bannerError: false,
      defaultDescription: '为您提供优质可靠的医药产品',
      currentSlide: 0, // 当前轮播图索引
      fragmentingSlide: -1, // 正在破碎的轮播图索引
      assemblingSlide: -1, // 正在重组的轮播图索引
      autoplayTimer: null, // 自动播放定时器
      isTransitioning: false, // 是否正在过渡中
      // 药品相关数据
      medicineList: [],
      medicineLoading: false,
      medicineError: null,
      medicinePagination: {
        currentPage: 1,
        pageSize: 20,
        total: 0
      },
      // 公司简介数据
      aboutUsData: {},
      aboutUsLoading: false,
      aboutUsError: null,
      qualificationList: [
        new URL('../assets/qualisication/D_5.png', import.meta.url).href,
        new URL('../assets/qualisication/D_11.png', import.meta.url).href,
        new URL('../assets/qualisication/7.png', import.meta.url).href,
        new URL('../assets/qualisication/D_8.jpg', import.meta.url).href,
        new URL('../assets/qualisication/9.jpg', import.meta.url).href,
        new URL('../assets/qualisication/10.png', import.meta.url).href,
      ]
    }
  },
  computed: {
    // ... existing code ...
  },
  methods: {
    // 加载轮播图数据
    async loadBannerData() {
      try {
        this.bannerLoading = true
        this.bannerError = false

        const data = await getBanners()

        // 过滤状态正常的轮播图
        this.bannerList = data.filter(item => item.status === 'normal')

        // 如果没有轮播图数据，使用默认图片
        if (this.bannerList.length === 0) {
          this.useDefaultBanners()
        }

        this.bannerLoading = false
      } catch (error) {
        console.error('轮播图加载错误:', error)
        this.bannerLoading = false
        this.bannerError = true

        // 出错时使用默认轮播图
        this.useDefaultBanners()
      }
    },

    // 使用默认轮播图数据（当API请求失败时）
    useDefaultBanners() {
      this.bannerList = [
        {
          id: 1,
          title: '专业品质 · 呵护健康',
          description: '为您提供优质可靠的医药产品',
          url: '',
          image_url: placeholderImages.banner1,
          background_color: '#3a8ee6'
        },
        {
          id: 2,
          title: '全面呵护 · 健康生活',
          description: '多种药品类型，满足您的各种健康需求',
          url: '',
          image_url: placeholderImages.banner2,
          background_color: '#42b983'
        },
        {
          id: 3,
          title: '专业团队 · 质量保障',
          description: '严格的质量控制流程，呵护您的健康',
          url: '',
          image_url: placeholderImages.banner3,
          background_color: '#e74c3c'
        }
      ]
      this.bannerError = false
      this.bannerLoading = false
    },

    // 加载药品数据
    async loadMedicineData() {
      this.medicineLoading = true;
      this.medicineError = null;

      try {
        const { currentPage, pageSize } = this.medicinePagination;
        const response = await getMedicines({
          page: currentPage,
          pagesize: pageSize
        });

        if (response.code === 1) {
          this.medicineList = response.data.data;
          this.medicinePagination.total = response.data.total;
        } else {
          this.medicineError = response.msg || '获取药品数据失败';
        }
      } catch (error) {
        console.error('获取药品数据错误:', error);
        this.medicineError = '网络错误，请稍后重试';
      } finally {
        this.medicineLoading = false;
      }
    },

    // 页码变化
    handleCurrentChange(page) {
      this.medicinePagination.currentPage = page;
      this.loadMedicineData();
    },

    // 提取短厂商名称
    getShortManufacturer(manufacturer) {
      if (!manufacturer) return '暂无';
      // 如果厂商名称太长，只显示前10个字符加...
      return manufacturer.length > 10 ? manufacturer.substring(0, 10) + '...' : manufacturer;
    },

    // 从描述HTML中提取纯文本短描述
    getShortDescription(description) {
      if (!description) return '';
      // 创建临时DOM元素来解析HTML
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = description;
      const text = tempDiv.textContent || tempDiv.innerText || '';
      return text.substring(0, 50) + (text.length > 50 ? '...' : '');
    },

    // 从适应症HTML中提取纯文本短描述
    getShortIndications(indications) {
      if (!indications) return '';
      // 创建临时DOM元素来解析HTML
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = indications;
      const text = tempDiv.textContent || tempDiv.innerText || '';
      return text.substring(0, 50) + (text.length > 50 ? '...' : '');
    },

    // 获取完整图片URL
    getFullImageUrl(path) {
      if (!path) return null;

      // 如果已经是完整URL则直接返回
      if (path.startsWith('http://') || path.startsWith('https://')) {
        return path;
      }

      // 否则拼接基础URL
      return `${BASE_URL}${path}`;
    },

    // 加载公司简介数据
    async loadAboutUsData() {
      this.aboutUsLoading = true;
      this.aboutUsError = null;

      try {
        const response = await getAboutUs();

        if (response.code === 1) {
          this.aboutUsData = response.data;
        } else {
          this.aboutUsError = response.msg || '获取公司简介失败';
        }
      } catch (error) {
        console.error('获取公司简介错误:', error);
        this.aboutUsError = '网络错误，请稍后重试';
      } finally {
        this.aboutUsLoading = false;
      }
    },

    // 破碎重组轮播图控制方法
    goToSlide(index) {
      if (this.isTransitioning || index === this.currentSlide) return;
      this.transitionToSlide(index);
    },

    // 上一张
    prevSlide() {
      if (this.isTransitioning) return;
      const prevIndex = this.currentSlide === 0 ? this.bannerList.length - 1 : this.currentSlide - 1;
      this.transitionToSlide(prevIndex);
    },

    // 下一张
    nextSlide() {
      if (this.isTransitioning) return;
      const nextIndex = this.currentSlide === this.bannerList.length - 1 ? 0 : this.currentSlide + 1;
      this.transitionToSlide(nextIndex);
    },

    // 过渡到指定幻灯片
    async transitionToSlide(targetIndex) {
      if (this.isTransitioning) return;

      this.isTransitioning = true;
      this.fragmentingSlide = this.currentSlide;

      // 等待破碎动画完成
      await new Promise(resolve => setTimeout(resolve, 800));

      // 开始重组新的幻灯片
      this.assemblingSlide = targetIndex;
      this.currentSlide = targetIndex;
      this.fragmentingSlide = -1;

      // 等待重组动画完成
      await new Promise(resolve => setTimeout(resolve, 800));

      this.assemblingSlide = -1;
      this.isTransitioning = false;
    },

    // 获取碎片位置
    getFragmentPosition(index) {
      const row = Math.floor((index - 1) / 5);
      const col = (index - 1) % 5;
      const x = col * 20; // 每个碎片占20%宽度
      const y = row * 20; // 每个碎片占20%高度
      return `${x}% ${y}%`;
    },

    // 获取碎片动画延迟
    getFragmentDelay(index) {
      // 从中心向外扩散的延迟模式
      const row = Math.floor((index - 1) / 5);
      const col = (index - 1) % 5;
      const centerRow = 2;
      const centerCol = 2;
      const distance = Math.abs(row - centerRow) + Math.abs(col - centerCol);
      return `${distance * 0.05}s`;
    },

    // 开始自动播放
    startAutoplay() {
      this.stopAutoplay();
      this.autoplayTimer = setInterval(() => {
        this.nextSlide();
      }, 5000);
    },

    // 停止自动播放
    stopAutoplay() {
      if (this.autoplayTimer) {
        clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    },

    // 处理轮播图变化
    handleSlideChange(index) {
      this.currentSlide = index;
    },

    // 安全的HTML处理
    sanitizeHtml(html) {
      // 简单的HTML清理，移除潜在危险标签
      if (!html) return '';
      return html.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '')
                 .replace(/<iframe\b[^<]*(?:(?!<\/iframe>)<[^<]*)*<\/iframe>/gi, '')
                 .replace(/on\w+="[^"]*"/gi, '');
    },


    // 获取卡片样式
    getCardStyle(index) {
      const delay = index * 0.1;
      return {
        animationDelay: `${delay}s`
      };
    },

    // 获取下一张轮播图索引
    getNextSlideIndex() {
      return this.currentSlide === this.bannerList.length - 1 ? 0 : this.currentSlide + 1;
    },

    // 获取上一张轮播图索引
    getPrevSlideIndex() {
      return this.currentSlide === 0 ? this.bannerList.length - 1 : this.currentSlide - 1;
    },

    // 更新粒子样式生成
    getParticleStyle(index) {
      const colors = ['#60A5FA', '#A855F7', '#EC4899', '#F59E0B', '#10B981'];
      const size = Math.random() * 3 + 1;
      const x = Math.random() * 100;
      const y = Math.random() * 100;
      const duration = Math.random() * 20 + 10;
      const delay = Math.random() * 5;

      return {
        width: `${size}px`,
        height: `${size}px`,
        left: `${x}%`,
        top: `${y}%`,
        backgroundColor: colors[index % colors.length],
        animationDuration: `${duration}s`,
        animationDelay: `${delay}s`,
        borderRadius: '50%',
        opacity: Math.random() * 0.8 + 0.2
      };
    }
  },
  created() {
    this.loadBannerData();
    this.loadMedicineData();
    this.loadAboutUsData();
  },
  mounted() {
    // 启动自动播放
    this.startAutoplay();
  },
  beforeUnmount() {
    // 清理定时器
    this.stopAutoplay();
  }
}
</script>

<style scoped>
/* 全局重置 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* 根容器 - 全新设计 */
.neo-pharma-home {
  font-family: 'Inter', 'SF Pro Display', -apple-system, BlinkMacSystemFont, sans-serif;
  color: #ffffff;
  line-height: 1.6;
  background: #0A0A0F;
  min-height: 100vh;
  position: relative;
  overflow-x: hidden;
}

/* ===========================================
   全新流体英雄区域样式
   ========================================== */

.fluid-hero-section {
  position: relative;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 20px;
  background:
    radial-gradient(ellipse at top left, rgba(59, 130, 246, 0.15) 0%, transparent 50%),
    radial-gradient(ellipse at top right, rgba(168, 85, 247, 0.15) 0%, transparent 50%),
    radial-gradient(ellipse at bottom, rgba(236, 72, 153, 0.15) 0%, transparent 50%),
    linear-gradient(135deg, #0A0A0F 0%, #1a1a2e 50%, #16213e 100%);
  overflow: hidden;
}

/* 动态背景粒子 */
.particle-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 1;
}

.particle {
  position: absolute;
  background: rgba(255, 255, 255, 0.6);
  border-radius: 50%;
  animation: particleFloat 15s infinite linear;
  box-shadow: 0 0 6px rgba(255, 255, 255, 0.4);
}

@keyframes particleFloat {
  0% {
    transform: translateY(100vh) rotate(0deg);
    opacity: 0;
  }
  10% {
    opacity: 1;
  }
  90% {
    opacity: 1;
  }
  100% {
    transform: translateY(-100px) rotate(360deg);
    opacity: 0;
  }
}

/* 流体形状背景 */
.fluid-shapes {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  pointer-events: none;
}

.fluid-shape {
  position: absolute;
  border-radius: 50%;
  filter: blur(100px);
  animation: fluidMove 20s ease-in-out infinite;
}

.shape-1 {
  width: 600px;
  height: 600px;
  background: linear-gradient(45deg, rgba(59, 130, 246, 0.3), rgba(168, 85, 247, 0.3));
  top: -300px;
  left: -300px;
  animation-delay: 0s;
}

.shape-2 {
  width: 800px;
  height: 800px;
  background: linear-gradient(135deg, rgba(236, 72, 153, 0.2), rgba(245, 158, 11, 0.2));
  top: -400px;
  right: -400px;
  animation-delay: -7s;
}

.shape-3 {
  width: 500px;
  height: 500px;
  background: linear-gradient(225deg, rgba(16, 185, 129, 0.25), rgba(59, 130, 246, 0.25));
  bottom: -250px;
  left: 50%;
  transform: translateX(-50%);
  animation-delay: -14s;
}

@keyframes fluidMove {
  0%, 100% {
    transform: translateX(0) translateY(0) scale(1);
  }
  25% {
    transform: translateX(100px) translateY(-100px) scale(1.1);
  }
  50% {
    transform: translateX(-50px) translateY(50px) scale(0.9);
  }
  75% {
    transform: translateX(-100px) translateY(-50px) scale(1.05);
  }
}

/* 英雄区域内容容器 */
.hero-content-wrapper {
  position: relative;
  z-index: 10;
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
}

/* 加载状态 - 现代化设计 */
.neo-loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
}

.loading-orb {
  position: relative;
  width: 80px;
  height: 80px;
  margin-bottom: 20px;
}

.orb-ring {
  position: absolute;
  width: 100%;
  height: 100%;
  border: 3px solid rgba(59, 130, 246, 0.3);
  border-top: 3px solid #3b82f6;
  border-radius: 50%;
  animation: orbSpin 1s linear infinite;
}

.orb-core {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60%;
  height: 60%;
  background: radial-gradient(circle, rgba(59, 130, 246, 0.8), rgba(168, 85, 247, 0.8));
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: orbPulse 2s ease-in-out infinite;
}

@keyframes orbSpin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@keyframes orbPulse {
  0%, 100% { transform: translate(-50%, -50%) scale(1); }
  50% { transform: translate(-50%, -50%) scale(1.1); }
}

.loading-text {
  color: rgba(255, 255, 255, 0.8);
  font-size: 16px;
  font-weight: 500;
}

/* 错误状态 */
.neo-error-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 60px 20px;
}

.error-icon-wrapper {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, rgba(239, 68, 68, 0.2), rgba(248, 113, 113, 0.2));
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  border: 2px solid rgba(239, 68, 68, 0.3);
}

.error-icon {
  font-size: 32px;
  color: #ef4444;
}

.error-text {
  color: rgba(255, 255, 255, 0.8);
  text-align: center;
  margin-bottom: 20px;
}

.retry-btn {
  padding: 12px 30px;
  background: linear-gradient(135deg, #ef4444, #dc2626);
  color: white;
  border: none;
  border-radius: 25px;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.3s ease;
}

.retry-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 25px rgba(239, 68, 68, 0.4);
}

/* ===========================================
   全新轮播图容器和控件
   ========================================== */

.neo-carousel-container {
  position: relative;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}

.carousel-display {
  position: relative;
  height: 600px;
  border-radius: 24px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.02);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.3);
}

.carousel-slide {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  opacity: 0;
  transform: translateX(100%) scale(0.8);
  transition: all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  pointer-events: none;
}

.carousel-slide.slide-active {
  opacity: 1;
  transform: translateX(0) scale(1);
  pointer-events: auto;
  z-index: 3;
}

.carousel-slide.slide-next {
  transform: translateX(100%) scale(0.9);
  opacity: 0.3;
  z-index: 2;
}

.carousel-slide.slide-prev {
  transform: translateX(-100%) scale(0.9);
  opacity: 0.3;
  z-index: 1;
}

.slide-image-container {
  flex: 1;
  height: 100%;
  position: relative;
  overflow: hidden;
}

.image-frame {
  width: 100%;
  height: 100%;
  position: relative;
  border-radius: 20px;
  overflow: hidden;
}

.image-frame img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.8s ease;
}

.slide-active .image-frame img {
  transform: scale(1.05);
}

.image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg,
    rgba(0, 0, 0, 0.4) 0%,
    rgba(0, 0, 0, 0.1) 50%,
    rgba(0, 0, 0, 0.3) 100%);
}

.slide-content {
  flex: 1;
  padding: 60px 50px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  z-index: 5;
}

.content-badge {
  display: inline-block;
  padding: 6px 16px;
  background: linear-gradient(135deg, #3b82f6, #8b5cf6);
  color: white;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
  border-radius: 20px;
  margin-bottom: 20px;
  width: fit-content;
  box-shadow: 0 4px 15px rgba(59, 130, 246, 0.4);
}

.slide-title {
  font-size: 3.5rem;
  font-weight: 800;
  line-height: 1.1;
  margin-bottom: 20px;
  background: linear-gradient(135deg, #ffffff 0%, #e2e8f0 100%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  text-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
}

.slide-description {
  font-size: 1.3rem;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.9);
  margin-bottom: 40px;
  max-width: 500px;
}

.slide-actions {
  display: flex;
  gap: 20px;
  align-items: center;
}

/* 全新按钮样式 */
.neo-btn {
  position: relative;
  padding: 16px 32px;
  border-radius: 30px;
  font-weight: 700;
  font-size: 16px;
  text-decoration: none;
  border: none;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  overflow: hidden;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.neo-btn-primary {
  background: linear-gradient(135deg, #3b82f6 0%, #8b5cf6 50%, #ec4899 100%);
  background-size: 200% 200%;
  color: white;
  box-shadow: 0 8px 25px rgba(59, 130, 246, 0.4);
  animation: gradientShift 4s ease infinite;
}

.neo-btn-primary:hover {
  transform: translateY(-3px) scale(1.05);
  box-shadow: 0 15px 35px rgba(59, 130, 246, 0.6);
}

.neo-btn-ghost {
  background: rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.9);
  border: 2px solid rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(10px);
}

.neo-btn-ghost:hover {
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.6);
  transform: translateY(-2px);
}

.btn-glow {
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
  transition: left 0.8s ease;
}

.neo-btn-primary:hover .btn-glow {
  left: 100%;
}

@keyframes gradientShift {
  0%, 100% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
}

/* 轮播图控制按钮 */
.carousel-controls {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  transform: translateY(-50%);
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
  pointer-events: none;
  z-index: 10;
}

.control-btn {
  width: 60px;
  height: 60px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(20px);
  border: 2px solid rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.4s ease;
  pointer-events: auto;
}

.control-btn:hover {
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.4);
  transform: scale(1.1);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
}

/* 轮播图指示器 */
.carousel-indicators {
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 12px;
  z-index: 10;
}

.indicator {
  width: 50px;
  height: 6px;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 3px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: all 0.4s ease;
}

.indicator.active {
  background: rgba(255, 255, 255, 0.6);
  box-shadow: 0 0 15px rgba(255, 255, 255, 0.4);
}

.indicator-progress {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  background: linear-gradient(90deg, #3b82f6, #8b5cf6);
  border-radius: 3px;
  width: 0;
  transition: width 0.4s ease;
}

.indicator.active .indicator-progress {
  width: 100%;
}

/* ===========================================
   全新药品展示区域样式
   ========================================== */

.neo-medicine-showcase {
  position: relative;
  padding: 120px 0;
  background: linear-gradient(135deg, #0F0F1E 0%, #1A1A2E 50%, #16213E 100%);
  overflow: hidden;
}

.showcase-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  pointer-events: none;
}

.bg-grid {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image:
    linear-gradient(rgba(255, 255, 255, 0.03) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 255, 255, 0.03) 1px, transparent 1px);
  background-size: 50px 50px;
  animation: gridMove 20s linear infinite;
}

@keyframes gridMove {
  0% { transform: translate(0, 0); }
  100% { transform: translate(50px, 50px); }
}

.bg-orbs {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(40px);
  animation: orbFloat 15s ease-in-out infinite;
}

.orb-1 {
  width: 300px;
  height: 300px;
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.2), rgba(168, 85, 247, 0.2));
  top: 10%;
  left: 10%;
  animation-delay: 0s;
}

.orb-2 {
  width: 200px;
  height: 200px;
  background: linear-gradient(135deg, rgba(236, 72, 153, 0.15), rgba(245, 158, 11, 0.15));
  top: 60%;
  right: 15%;
  animation-delay: -5s;
}

.orb-3 {
  width: 250px;
  height: 250px;
  background: linear-gradient(135deg, rgba(16, 185, 129, 0.18), rgba(59, 130, 246, 0.18));
  bottom: 20%;
  left: 50%;
  animation-delay: -10s;
}

@keyframes orbFloat {
  0%, 100% { transform: translate(0, 0) rotate(0deg); }
  25% { transform: translate(30px, -40px) rotate(90deg); }
  50% { transform: translate(-20px, 20px) rotate(180deg); }
  75% { transform: translate(-40px, -30px) rotate(270deg); }
}

.showcase-container {
  position: relative;
  z-index: 10;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
}

.showcase-header {
  margin-bottom: 80px;
}

.header-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 40px;
}

.title-section {
  flex: 1;
}

.title-badge {
  position: relative;
  display: inline-block;
  padding: 8px 24px;
  background: rgba(59, 130, 246, 0.1);
  border: 1px solid rgba(59, 130, 246, 0.3);
  border-radius: 25px;
  color: #60a5fa;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  margin-bottom: 20px;
  overflow: hidden;
}

.badge-glow {
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(59, 130, 246, 0.3), transparent);
  animation: badgeGlow 3s ease-in-out infinite;
}

@keyframes badgeGlow {
  0%, 100% { left: -100%; }
  50% { left: 100%; }
}

.section-title {
  font-size: 4rem;
  font-weight: 900;
  line-height: 1.1;
  margin-bottom: 15px;
  color: white;
}

.title-accent {
  background: linear-gradient(135deg, #3b82f6 0%, #8b5cf6 50%, #ec4899 100%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.section-subtitle {
  color: rgba(255, 255, 255, 0.7);
  font-size: 1.2rem;
  line-height: 1.6;
}

.view-all-link {
  display: flex;
  align-items: center;
  gap: 12px;
  color: #60a5fa;
  text-decoration: none;
  font-weight: 600;
  font-size: 16px;
  transition: all 0.3s ease;
  padding: 12px 24px;
  border: 1px solid rgba(96, 165, 250, 0.3);
  border-radius: 25px;
  background: rgba(96, 165, 250, 0.1);
  backdrop-filter: blur(10px);
}

.view-all-link:hover {
  border-color: rgba(96, 165, 250, 0.6);
  background: rgba(96, 165, 250, 0.2);
  transform: translateY(-2px);
}

.link-arrow {
  transition: transform 0.3s ease;
}

.view-all-link:hover .link-arrow {
  transform: translateX(4px);
}

/* 药品网格布局 */
.medicine-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 30px;
  animation: fadeInUp 0.8s ease;
}

.medicine-card {
  position: relative;
  background: rgba(255, 255, 255, 0.03);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 24px;
  overflow: hidden;
  transition: all 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  animation: cardReveal 0.8s ease var(--delay) both;
}

@keyframes cardReveal {
  0% {
  opacity: 0;
    transform: translateY(50px) scale(0.9);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.medicine-card:hover {
  transform: translateY(-10px) scale(1.02);
  border-color: rgba(255, 255, 255, 0.2);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
}

.card-bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0;
  transition: opacity 0.6s ease;
}

.medicine-card:hover .card-bg {
  opacity: 1;
}

.card-shine {
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: conic-gradient(from 0deg, transparent, rgba(59, 130, 246, 0.1), transparent);
  animation: rotate 10s linear infinite;
}

.card-gradient {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg,
    rgba(59, 130, 246, 0.05) 0%,
    rgba(168, 85, 247, 0.05) 50%,
    rgba(236, 72, 153, 0.05) 100%);
}

@keyframes rotate {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.card-image-wrapper {
  position: relative;
  height: 200px;
  overflow: hidden;
}

.image-container {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
}

.image-container img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: all 0.6s ease;
}

.medicine-card:hover .image-container img {
  transform: scale(1.1);
}

.image-glow {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(circle at center, rgba(59, 130, 246, 0.2) 0%, transparent 70%);
  opacity: 0;
  transition: opacity 0.6s ease;
}

.medicine-card:hover .image-glow {
  opacity: 1;
}

.image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.medicine-card:hover .image-overlay {
  opacity: 1;
}

.quick-action-btn {
  width: 50px;
  height: 50px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #3b82f6;
  transition: all 0.3s ease;
  text-decoration: none;
}

.quick-action-btn:hover {
  background: white;
  transform: scale(1.1);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
}

.category-tag {
  position: absolute;
  top: 15px;
  right: 15px;
  background: linear-gradient(135deg, #3b82f6, #8b5cf6);
  color: white;
  padding: 6px 12px;
  border-radius: 15px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.card-content {
  padding: 30px 25px;
}

.product-name {
  font-size: 1.4rem;
  font-weight: 700;
  color: white;
  margin-bottom: 20px;
  line-height: 1.3;
}

.product-meta {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 20px;
}

.meta-item {
  display: flex;
  align-items: center;
  gap: 12px;
}

.meta-icon {
  width: 20px;
  height: 20px;
  color: #60a5fa;
  flex-shrink: 0;
}

.meta-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.meta-label {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.meta-value {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.9);
  font-weight: 500;
}

.product-description {
  font-size: 14px;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 25px;
}

.card-actions {
  display: flex;
  justify-content: flex-end;
}

.action-btn {
  position: relative;
  padding: 12px 24px;
  background: transparent;
  color: #60a5fa;
  border: 1px solid rgba(96, 165, 250, 0.3);
  border-radius: 20px;
  text-decoration: none;
  font-weight: 600;
  font-size: 14px;
  transition: all 0.3s ease;
  overflow: hidden;
}

.action-btn:hover {
  border-color: rgba(96, 165, 250, 0.6);
  background: rgba(96, 165, 250, 0.1);
  transform: translateY(-2px);
}

.btn-bg {
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(96, 165, 250, 0.2), transparent);
  transition: left 0.6s ease;
}

.action-btn:hover .btn-bg {
  left: 100%;
}

.fragment-carousel-item.assembling .banner-image img {
  animation: slideInScale 1.2s ease-in-out forwards;
}

/* ===========================================
   全新关于我们区域样式
   ========================================== */

.neo-about-section {
  position: relative;
  padding: 120px 0;
  background: linear-gradient(135deg, #1A1A2E 0%, #16213E 50%, #0F0F1E 100%);
  overflow: hidden;
}

.about-bg-layers {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  pointer-events: none;
}

.layer {
  position: absolute;
  border-radius: 50%;
  filter: blur(60px);
  animation: layerFloat 20s ease-in-out infinite;
}

.layer-1 {
  width: 400px;
  height: 400px;
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.15), rgba(168, 85, 247, 0.15));
  top: -200px;
  left: -200px;
  animation-delay: 0s;
}

.layer-2 {
  width: 300px;
  height: 300px;
  background: linear-gradient(135deg, rgba(236, 72, 153, 0.12), rgba(245, 158, 11, 0.12));
  top: 50%;
  right: -150px;
  animation-delay: -7s;
}

.layer-3 {
  width: 350px;
  height: 350px;
  background: linear-gradient(135deg, rgba(16, 185, 129, 0.13), rgba(59, 130, 246, 0.13));
  bottom: -175px;
  left: 40%;
  animation-delay: -14s;
}

@keyframes layerFloat {
  0%, 100% { transform: translate(0, 0) rotate(0deg); }
  33% { transform: translate(50px, -60px) rotate(120deg); }
  66% { transform: translate(-30px, 40px) rotate(240deg); }
}

.about-container {
  position: relative;
  z-index: 10;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
}

.about-content-wrapper {
  position: relative;
}

.about-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 60px;
  align-items: start;
}

.main-info-card {
  position: relative;
  background: rgba(255, 255, 255, 0.03);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 24px;
  padding: 50px;
  overflow: hidden;
}

.card-glow-bg {
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: conic-gradient(from 0deg, transparent, rgba(59, 130, 246, 0.1), transparent, rgba(168, 85, 247, 0.1), transparent);
  animation: rotate 15s linear infinite;
  opacity: 0.5;
}

.info-header {
  position: relative;
  z-index: 2;
  margin-bottom: 40px;
}

.company-badge {
  position: relative;
  display: inline-block;
  padding: 8px 20px;
  background: rgba(59, 130, 246, 0.1);
  border: 1px solid rgba(59, 130, 246, 0.3);
  border-radius: 20px;
  margin-bottom: 20px;
  overflow: hidden;
}

.badge-text {
  color: #60a5fa;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  position: relative;
  z-index: 2;
}

.badge-particles {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.badge-particles .particle {
  position: absolute;
  width: 2px;
  height: 2px;
  background: #60a5fa;
  border-radius: 50%;
  animation: particleBadge 2s ease-in-out infinite;
}

.badge-particles .particle:nth-child(1) { top: 20%; left: 10%; animation-delay: 0s; }
.badge-particles .particle:nth-child(2) { top: 60%; left: 20%; animation-delay: 0.3s; }
.badge-particles .particle:nth-child(3) { top: 30%; left: 80%; animation-delay: 0.6s; }
.badge-particles .particle:nth-child(4) { top: 70%; left: 70%; animation-delay: 0.9s; }
.badge-particles .particle:nth-child(5) { top: 40%; left: 50%; animation-delay: 1.2s; }
.badge-particles .particle:nth-child(6) { top: 80%; left: 90%; animation-delay: 1.5s; }

@keyframes particleBadge {
  0%, 100% { opacity: 0.3; transform: scale(1); }
  50% { opacity: 1; transform: scale(1.5); }
}

.company-title {
  color: #ffffff !important;
  font-size: 3.5rem;
  font-weight: 900;
  line-height: 1.1;
  margin-bottom: 20px;
}

.title-highlight {
  background: linear-gradient(135deg, #3b82f6 0%, #8b5cf6 50%, #ec4899 100%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.company-tagline {
  color: #ffffff !important;
  font-size: 1.3rem;
  line-height: 1.6;
  margin-bottom: 30px;
}

.info-content {
  position: relative;
  z-index: 2;
}

.description-wrapper {
  color: #ffffff !important;
}

.description-wrapper * {
  color: #ffffff !important;
}

.company-description {
  color: #ffffff !important;
  font-size: 1.1rem;
  line-height: 1.8;
  margin-bottom: 40px;
}

.company-description p {
  color: #ffffff !important;
  margin-bottom: 20px;
}

.cta-section {
  display: flex;
  align-items: center;
}

.neo-cta-btn {
  position: relative;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 32px;
  background: linear-gradient(135deg, #3b82f6, #8b5cf6);
  color: white;
  text-decoration: none;
  border-radius: 30px;
  font-weight: 700;
  transition: all 0.4s ease;
  overflow: hidden;
}

.neo-cta-btn:hover {
  transform: translateY(-3px) scale(1.05);
  box-shadow: 0 15px 30px rgba(59, 130, 246, 0.4);
}

.btn-text {
  position: relative;
  z-index: 2;
}

.btn-icon {
  position: relative;
  z-index: 2;
  transition: transform 0.3s ease;
}

.neo-cta-btn:hover .btn-icon {
  transform: translateX(4px) rotate(45deg);
}

.btn-glow {
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
  transition: left 0.6s ease;
}

.neo-cta-btn:hover .btn-glow {
  left: 100%;
}


/* 核心价值区域 */
.values-section {
  grid-column: 1 / -1;
  margin-top: 40px;
}

.values-title {
  font-size: 2.5rem;
  font-weight: 800;
  color: white;
  text-align: center;
  margin-bottom: 50px;
}

.values-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
}

.value-item {
  position: relative;
  background: rgba(255, 255, 255, 0.03);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  padding: 40px 30px;
  text-align: center;
  transition: all 0.4s ease;
  overflow: hidden;
}

.value-item:hover {
  transform: translateY(-10px);
  border-color: rgba(255, 255, 255, 0.2);
}

.value-bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.03), rgba(168, 85, 247, 0.03));
  opacity: 0;
  transition: opacity 0.4s ease;
}

.value-item:hover .value-bg {
  opacity: 1;
}

.value-icon-wrapper {
  position: relative;
  width: 80px;
  height: 80px;
  margin: 0 auto 25px;
  border-radius: 50%;
  background: rgba(59, 130, 246, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.4s ease;
}

.value-item:hover .value-icon-wrapper {
  background: rgba(59, 130, 246, 0.2);
  transform: scale(1.1);
}

.value-icon {
  color: #60a5fa;
  position: relative;
  z-index: 2;
}

.value-name {
  font-size: 1.4rem;
  font-weight: 700;
  color: white;
  margin-bottom: 15px;
}

.value-desc {
  color: rgba(255, 255, 255, 0.7);
  font-size: 1rem;
  line-height: 1.6;
}

/* 通用状态样式 */
.loading-spinner {
  position: relative;
  width: 60px;
  height: 60px;
  margin: 0 auto 20px;
}

.spinner-ring {
  position: absolute;
  width: 100%;
  height: 100%;
  border: 3px solid rgba(59, 130, 246, 0.3);
  border-top: 3px solid #3b82f6;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.spinner-dot {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 8px;
  height: 8px;
  background: #3b82f6;
  border-radius: 50%;
  animation: pulse 1.5s ease-in-out infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@keyframes pulse {
  0%, 100% { opacity: 1; transform: translate(-50%, -50%) scale(1); }
  50% { opacity: 0.5; transform: translate(-50%, -50%) scale(1.2); }
}

.neo-retry-btn, .neo-error-state .neo-retry-btn {
  position: relative;
  padding: 12px 30px;
  background: linear-gradient(135deg, #ef4444, #dc2626);
  color: white;
  border: none;
  border-radius: 25px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  overflow: hidden;
}

.neo-retry-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 25px rgba(239, 68, 68, 0.4);
}

.btn-wave, .btn-ripple {
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
  transition: left 0.6s ease;
}

.neo-retry-btn:hover .btn-wave,
.neo-retry-btn:hover .btn-ripple {
  left: 100%;
}

/* 分页样式 */
.neo-pagination {
  margin-top: 60px;
  display: flex;
  justify-content: center;
}

/* 错误和空状态 */
.error-visual, .empty-visual {
  width: 100px;
  height: 100px;
  margin: 0 auto 20px;
  background: rgba(239, 68, 68, 0.1);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid rgba(239, 68, 68, 0.3);
}

.error-circle, .empty-icon {
  width: 60px;
  height: 60px;
  background: rgba(239, 68, 68, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.error-message, .empty-message {
  color: rgba(255, 255, 255, 0.7);
  text-align: center;
  margin-bottom: 25px;
  font-size: 1.1rem;
}

/* ===========================================
   通用动画和响应式设计
   ========================================== */

@keyframes fadeInUp {
  0% {
    opacity: 0;
    transform: translateY(30px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .fluid-hero-section {
    padding: 0 15px;
  }

  .carousel-display {
    height: 500px;
  }

  .slide-title {
    font-size: 2.8rem;
  }

  .medicine-grid {
    grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
    gap: 25px;
  }

  .about-grid {
    gap: 40px;
  }

}

@media (max-width: 768px) {
  .fluid-hero-section {
    min-height: 80vh;
    padding: 0 15px;
  }

  .carousel-display {
    height: 400px;
    flex-direction: column;
  }

  .slide-image-container {
    height: 60%;
  }

  .slide-content {
    padding: 30px 25px;
    flex: 1;
  }

  .slide-title {
    font-size: 2.2rem;
    margin-bottom: 15px;
  }

  .slide-description {
    font-size: 1.1rem;
    margin-bottom: 25px;
  }

  .slide-actions {
    flex-direction: column;
    gap: 15px;
    align-items: stretch;
  }

  .neo-btn {
    padding: 14px 28px;
    font-size: 15px;
  }

  .control-btn {
    width: 50px;
    height: 50px;
  }

  .carousel-controls {
    padding: 0 15px;
  }

  .medicine-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .showcase-container {
    padding: 0 15px;
  }

  .header-wrapper {
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 30px;
  }

  .section-title {
    font-size: 2.8rem;
  }

  .about-container {
    padding: 0 15px;
  }

  .main-info-card {
    padding: 40px 30px;
  }

  .company-title {
    font-size: 2.5rem;
  }

  .company-tagline {
    font-size: 1.1rem;
  }


  .values-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .value-item {
    padding: 30px 25px;
  }

  .values-title {
    font-size: 2rem;
  }
}

@media (max-width: 480px) {
  .slide-title {
    font-size: 1.8rem;
  }

  .slide-description {
    font-size: 1rem;
  }

  .section-title {
    font-size: 2.2rem;
  }

  .company-title {
    font-size: 2rem;
  }

  .medicine-card {
    border-radius: 20px;
  }

  .card-content {
    padding: 25px 20px;
  }

  .main-info-card {
    padding: 30px 25px;
    border-radius: 20px;
  }

  .value-item {
    padding: 25px 20px;
  }

  .value-icon-wrapper {
    width: 60px;
    height: 60px;
  }

}

/* 通用工具样式 */
.text-gradient {
  background: linear-gradient(135deg, #3b82f6 0%, #8b5cf6 50%, #ec4899 100%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.glass-effect {
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.hover-lift {
  transition: transform 0.3s ease;
}

.hover-lift:hover {
  transform: translateY(-5px);
}

/* 滚动条样式 */
::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: #1a1a2e;
}

::-webkit-scrollbar-thumb {
  background: linear-gradient(135deg, #3b82f6, #8b5cf6);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(135deg, #2563eb, #7c3aed);
}






@keyframes rotateOut {
  0% {
    transform: rotateY(0deg) scale(1);
    opacity: 1;
  }
  100% {
    transform: rotateY(-90deg) scale(0.8);
    opacity: 0;
  }
}

@keyframes rotateIn {
  0% {
    transform: rotateY(90deg) scale(0.8);
    opacity: 0;
  }
  100% {
    transform: rotateY(0deg) scale(1);
    opacity: 1;
  }
}

/* 为每个碎片设置不同的随机位移 */
.fragment:nth-child(1) { --random-x: -300px; --random-y: -200px; }
.fragment:nth-child(2) { --random-x: -150px; --random-y: -250px; }
.fragment:nth-child(3) { --random-x: 0px; --random-y: -300px; }
.fragment:nth-child(4) { --random-x: 150px; --random-y: -250px; }
.fragment:nth-child(5) { --random-x: 300px; --random-y: -200px; }
.fragment:nth-child(6) { --random-x: -250px; --random-y: -100px; }
.fragment:nth-child(7) { --random-x: -100px; --random-y: -150px; }
.fragment:nth-child(8) { --random-x: 0px; --random-y: -100px; }
.fragment:nth-child(9) { --random-x: 100px; --random-y: -150px; }
.fragment:nth-child(10) { --random-x: 250px; --random-y: -100px; }
.fragment:nth-child(11) { --random-x: -300px; --random-y: 0px; }
.fragment:nth-child(12) { --random-x: -150px; --random-y: 0px; }
.fragment:nth-child(13) { --random-x: 0px; --random-y: 0px; }
.fragment:nth-child(14) { --random-x: 150px; --random-y: 0px; }
.fragment:nth-child(15) { --random-x: 300px; --random-y: 0px; }
.fragment:nth-child(16) { --random-x: -250px; --random-y: 100px; }
.fragment:nth-child(17) { --random-x: -100px; --random-y: 150px; }
.fragment:nth-child(18) { --random-x: 0px; --random-y: 100px; }
.fragment:nth-child(19) { --random-x: 100px; --random-y: 150px; }
.fragment:nth-child(20) { --random-x: 250px; --random-y: 100px; }
.fragment:nth-child(21) { --random-x: -300px; --random-y: 200px; }
.fragment:nth-child(22) { --random-x: -150px; --random-y: 250px; }
.fragment:nth-child(23) { --random-x: 0px; --random-y: 300px; }
.fragment:nth-child(24) { --random-x: 150px; --random-y: 250px; }
.fragment:nth-child(25) { --random-x: 300px; --random-y: 200px; }

.banner-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    45deg,
    rgba(0, 0, 0, 0.6) 0%,
    rgba(0, 0, 0, 0.3) 50%,
    rgba(0, 0, 0, 0.4) 100%
  );
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
}

.banner-content {
  text-align: center;
  color: white;
  max-width: 600px;
  padding: 0 20px;
}

.banner-title {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 16px;
  line-height: 1.2;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.banner-description {
  font-size: 1.1rem;
  line-height: 1.6;
  margin-bottom: 30px;
  opacity: 0.9;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}

.banner-actions {
  display: flex;
  justify-content: center;
  gap: 16px;
}

.action-btn {
  background: linear-gradient(45deg, #3a8ee6, #42b983);
  color: white;
  padding: 12px 30px;
  border-radius: 30px;
  text-decoration: none;
  font-weight: 600;
  font-size: 1rem;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(58, 142, 230, 0.3);
  border: 2px solid transparent;
}

.action-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 25px rgba(58, 142, 230, 0.4);
  background: linear-gradient(45deg, #42b983, #3a8ee6);
}





/* 现代化轮播图控制样式 */
.carousel-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.1);
  color: white;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  width: 70px;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  z-index: 30;
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
}

.carousel-arrow:hover {
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.6);
  transform: translateY(-50%) scale(1.15);
  box-shadow: 0 15px 40px rgba(59, 130, 246, 0.4);
}

.carousel-arrow svg {
  width: 28px;
  height: 28px;
}

.carousel-arrow-left {
  left: 3rem;
}

.carousel-arrow-right {
  right: 3rem;
}

.carousel-indicators {
  position: absolute;
  bottom: 3rem;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 1rem;
  z-index: 30;
}

.indicator {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.4);
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 2px solid rgba(255, 255, 255, 0.2);
  position: relative;
  overflow: hidden;
}

.indicator::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, #3b82f6, #8b5cf6, #ec4899);
  opacity: 0;
  transition: opacity 0.4s ease;
}

.indicator:hover {
  background: rgba(255, 255, 255, 0.6);
  transform: scale(1.3);
  border-color: rgba(255, 255, 255, 0.5);
}

.indicator:hover::before {
  opacity: 0.3;
}

.indicator.active {
  background: linear-gradient(135deg, #3b82f6, #8b5cf6);
  border-color: rgba(255, 255, 255, 0.8);
  transform: scale(1.4);
  box-shadow: 0 0 25px rgba(59, 130, 246, 0.6);
}

.indicator.active::before {
  opacity: 1;
}

/* 现代化轮播图响应式设计 */
@media (max-width: 1024px) {
  .hero-section {
    height: 80vh;
  }

  .banner-title {
    font-size: 3.5rem;
  }

  .banner-description {
    font-size: 1.5rem;
  }

  .banner-content {
    padding: 0 3rem;
  }

  .carousel-arrow {
    width: 60px;
    height: 60px;
  }

  .carousel-arrow svg {
    width: 24px;
    height: 24px;
  }

  .carousel-arrow-left {
    left: 2rem;
  }

  .carousel-arrow-right {
    right: 2rem;
  }

  .indicator {
    width: 14px;
    height: 14px;
  }
}

@media (max-width: 768px) {
  .hero-section {
    height: 70vh;
  }

  .banner-title {
    font-size: 2.8rem;
    margin-bottom: 1.5rem;
  }

  .banner-description {
    font-size: 1.3rem;
    margin-bottom: 2rem;
  }

  .banner-content {
    padding: 0 2rem;
  }

  .banner-actions {
    flex-direction: column;
    gap: 1.5rem;
  }

  .action-btn {
    padding: 1rem 2.5rem;
    font-size: 1rem;
  }

  .carousel-arrow {
    width: 50px;
    height: 50px;
  }

  .carousel-arrow svg {
    width: 20px;
    height: 20px;
  }

  .carousel-arrow-left {
    left: 1.5rem;
  }

  .carousel-arrow-right {
    right: 1.5rem;
  }

  .carousel-indicators {
    bottom: 2rem;
  }

  .indicator {
    width: 12px;
    height: 12px;
  }

  /* 移动端碎片网格调整 */
  .image-fragments {
    grid-template-columns: repeat(6, 1fr);
    grid-template-rows: repeat(5, 1fr);
  }
}

/* 震撼药品展示区域 - 现代化设计 */
.medicine-showcase {
  padding: 120px 20px;
  max-width: 1400px;
  margin: 0 auto;
  background: linear-gradient(135deg,
    rgba(59, 130, 246, 0.05) 0%,
    rgba(139, 92, 246, 0.08) 25%,
    rgba(236, 72, 153, 0.05) 50%,
    rgba(251, 191, 36, 0.08) 75%,
    rgba(34, 197, 94, 0.05) 100%);
  background-size: 400% 400%;
  animation: showcaseGradient 20s ease infinite;
  border-radius: 30px;
  position: relative;
  overflow: hidden;
  box-shadow: 0 50px 100px rgba(0, 0, 0, 0.1);
}

.medicine-showcase::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(circle at 20% 80%, rgba(59, 130, 246, 0.1) 0%, transparent 50%),
              radial-gradient(circle at 80% 20%, rgba(139, 92, 246, 0.1) 0%, transparent 50%),
              radial-gradient(circle at 40% 40%, rgba(236, 72, 153, 0.08) 0%, transparent 50%);
  pointer-events: none;
  animation: pulseGlow 8s ease-in-out infinite;
}

.medicine-showcase::after {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: conic-gradient(from 0deg, transparent, rgba(59, 130, 246, 0.03), transparent, rgba(139, 92, 246, 0.03), transparent);
  animation: rotate 30s linear infinite;
  pointer-events: none;
}

.showcase-header {
  margin-bottom: 80px;
  position: relative;
  overflow: hidden;
  z-index: 10;
}

.showcase-header::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 300%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent 0%,
    rgba(59, 130, 246, 0.1) 20%,
    rgba(139, 92, 246, 0.1) 40%,
    rgba(236, 72, 153, 0.1) 60%,
    rgba(251, 191, 36, 0.1) 80%,
    transparent 100%
  );
  animation: shimmer 4s ease-in-out infinite;
  filter: blur(1px);
}

@keyframes shimmer {
  0% { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
}

@keyframes showcaseGradient {
  0%, 100% {
    background-position: 0% 50%;
  }
  25% {
    background-position: 100% 50%;
  }
  50% {
    background-position: 100% 100%;
  }
  75% {
    background-position: 0% 100%;
  }
}

@keyframes pulseGlow {
  0%, 100% {
    opacity: 0.3;
    transform: scale(1);
  }
  50% {
    opacity: 0.6;
    transform: scale(1.05);
  }
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes gradientText {
  0%, 100% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
}

@keyframes cardFloat {
  0%, 100% {
    transform: translateY(0px) rotateX(0deg);
  }
  33% {
    transform: translateY(-5px) rotateX(1deg);
  }
  66% {
    transform: translateY(2px) rotateX(-1deg);
  }
}

@keyframes aboutGradient {
  0%, 100% {
    background-position: 0% 50%;
  }
  25% {
    background-position: 100% 50%;
  }
  50% {
    background-position: 100% 100%;
  }
  75% {
    background-position: 0% 100%;
  }
}

@keyframes aboutCardFloat {
  0%, 100% {
    transform: translateY(0px) rotateX(0deg) rotateY(0deg);
  }
  25% {
    transform: translateY(-8px) rotateX(2deg) rotateY(1deg);
  }
  50% {
    transform: translateY(0px) rotateX(0deg) rotateY(-1deg);
  }
  75% {
    transform: translateY(4px) rotateX(-1deg) rotateY(1deg);
  }
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 40px 50px;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(30px);
  -webkit-backdrop-filter: blur(30px);
  border-radius: 25px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15),
              0 0 0 1px rgba(255, 255, 255, 0.3),
              inset 0 1px 0 rgba(255, 255, 255, 0.4);
  position: relative;
  z-index: 1;
  overflow: hidden;
}

.header-content::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg,
    rgba(59, 130, 246, 0.03) 0%,
    rgba(139, 92, 246, 0.05) 50%,
    rgba(236, 72, 153, 0.03) 100%);
  pointer-events: none;
}

.header-content::after {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: conic-gradient(from 0deg, transparent, rgba(59, 130, 246, 0.02), transparent);
  animation: rotate 20s linear infinite;
  pointer-events: none;
}

.header-text {
  position: relative;
}

.header-text::before {
  content: '';
  position: absolute;
  left: -20px;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 60px;
  background: linear-gradient(45deg, #3a8ee6, #42b983);
  border-radius: 2px;
}

.header-text h2 {
  font-size: 3rem;
  background: linear-gradient(135deg,
    #3b82f6 0%,
    #8b5cf6 25%,
    #ec4899 50%,
    #f59e0b 75%,
    #10b981 100%);
  background-size: 200% 200%;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  margin-bottom: 15px;
  font-weight: 900;
  letter-spacing: -0.02em;
  position: relative;
  animation: gradientText 4s ease-in-out infinite;
  text-shadow: 0 0 30px rgba(59, 130, 246, 0.3);
}

.header-text h2::after {
  content: '';
  position: absolute;
  bottom: -8px;
  left: 0;
  width: 80px;
  height: 3px;
  background: linear-gradient(45deg, #3a8ee6, #42b983);
  border-radius: 2px;
  opacity: 0.7;
}

.header-text p {
  color: #666;
  font-size: 1.1rem;
  margin: 0;
  font-weight: 500;
  opacity: 0.9;
}

.view-all-btn {
  display: flex;
  align-items: center;
  gap: 10px;
  background: linear-gradient(135deg, #3a8ee6 0%, #42b983 100%);
  color: white;
  padding: 14px 28px;
  border-radius: 30px;
  text-decoration: none;
  font-weight: 600;
  font-size: 1rem;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  box-shadow: 0 6px 20px rgba(58, 142, 230, 0.3);
  position: relative;
  overflow: hidden;
}

.view-all-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: left 0.6s ease;
}

.view-all-btn:hover::before {
  left: 100%;
}

.view-all-btn:hover {
  transform: translateY(-3px) scale(1.05);
  box-shadow: 0 12px 35px rgba(58, 142, 230, 0.4);
}

.view-all-btn svg {
  transition: transform 0.3s ease;
}

.view-all-btn:hover svg {
  transform: translateX(4px);
}

.medicine-list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 30px;
  perspective: 1000px;
}

.medicine-item {
  display: flex;
  flex-direction: column;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(25px);
  -webkit-backdrop-filter: blur(25px);
  border-radius: 25px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.12),
              0 0 0 1px rgba(255, 255, 255, 0.4),
              inset 0 1px 0 rgba(255, 255, 255, 0.6);
  transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1);
  border: 2px solid rgba(255, 255, 255, 0.3);
  min-height: 400px;
  position: relative;
  transform-style: preserve-3d;
  animation: cardFloat 6s ease-in-out infinite;
}

.medicine-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg,
    rgba(59, 130, 246, 0.02) 0%,
    rgba(139, 92, 246, 0.04) 25%,
    rgba(236, 72, 153, 0.02) 50%,
    rgba(251, 191, 36, 0.04) 75%,
    rgba(34, 197, 94, 0.02) 100%);
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.6s ease;
}

.medicine-item::after {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: conic-gradient(from 0deg, transparent, rgba(59, 130, 246, 0.01), transparent);
  animation: rotate 15s linear infinite;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.6s ease;
}

.medicine-item:hover {
  transform: translateY(-15px) rotateX(5deg) rotateY(5deg) scale(1.02);
  box-shadow: 0 40px 100px rgba(59, 130, 246, 0.25),
              0 0 0 1px rgba(255, 255, 255, 0.6),
              inset 0 1px 0 rgba(255, 255, 255, 0.8);
}

.medicine-item:hover::before,
.medicine-item:hover::after {
  opacity: 1;
}

.item-image {
  width: 100%;
  height: 220px;
  position: relative;
  overflow: hidden;
  flex-shrink: 0;
  border-radius: 20px 20px 0 0;
}

.item-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: all 0.8s cubic-bezier(0.23, 1, 0.32, 1);
  filter: brightness(0.9) contrast(1.1) saturate(1.2);
}

.medicine-item:hover .item-image img {
  transform: scale(1.1) rotate(2deg);
  filter: brightness(1.1) contrast(1.2) saturate(1.4);
}

.medicine-item:hover .item-image img {
  transform: scale(1.1);
}

.image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.medicine-item:hover .image-overlay {
  opacity: 1;
}

.quick-view-btn {
  background: rgba(255, 255, 255, 0.9);
  color: #3a8ee6;
  border: none;
  padding: 10px;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}

.quick-view-btn:hover {
  background: #3a8ee6;
  color: white;
  transform: scale(1.1);
}

.item-content {
  flex: 1;
  padding: 30px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  z-index: 2;
}

.item-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 15px;
}

.item-title {
  font-size: 1.5rem;
  background: linear-gradient(135deg, #2c3e50 0%, #3b82f6 50%, #8b5cf6 100%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  margin: 0;
  font-weight: 800;
  line-height: 1.3;
  flex: 1;
  margin-right: 15px;
  margin-bottom: 10px;
}

.item-category {
  background: linear-gradient(135deg, #3b82f6, #8b5cf6, #ec4899);
  background-size: 200% 200%;
  color: white;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 0.85rem;
  font-weight: 700;
  white-space: nowrap;
  animation: gradientText 3s ease-in-out infinite;
  box-shadow: 0 4px 15px rgba(59, 130, 246, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
}

.item-details {
  flex: 1;
  margin-bottom: 15px;
}

.detail-row {
  display: flex;
  margin-bottom: 8px;
  align-items: flex-start;
}

.detail-label {
  font-size: 0.9rem;
  color: #666;
  font-weight: 600;
  min-width: 80px;
  margin-right: 10px;
}

.detail-value {
  font-size: 0.9rem;
  color: #333;
  flex: 1;
  line-height: 1.4;
}

.description-row .detail-value {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.item-actions {
  display: flex;
  justify-content: flex-end;
}

.detail-link {
  background: linear-gradient(135deg, #3b82f6, #8b5cf6);
  background-size: 200% 200%;
  color: white;
  border: 2px solid rgba(255, 255, 255, 0.2);
  padding: 12px 24px;
  border-radius: 25px;
  text-decoration: none;
  font-weight: 700;
  font-size: 0.95rem;
  transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1);
  position: relative;
  overflow: hidden;
  box-shadow: 0 8px 25px rgba(59, 130, 246, 0.3);
  backdrop-filter: blur(10px);
}

.detail-link::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
  transition: left 0.6s ease;
}

.detail-link:hover::before {
  left: 100%;
}

.detail-link:hover {
  background-position: 100% 100%;
  transform: translateY(-3px) scale(1.05);
  box-shadow: 0 15px 40px rgba(59, 130, 246, 0.5);
  border-color: rgba(255, 255, 255, 0.4);
}

/* 响应式设计 */
@media (max-width: 1024px) {
  .header-content {
    padding: 25px 30px;
  }

  .header-text h2 {
    font-size: 2.1rem;
  }
}

@media (max-width: 768px) {
  .medicine-showcase {
    padding: 80px 15px;
  }

  .medicine-list {
    grid-template-columns: 1fr;
    gap: 25px;
  }

  .medicine-item {
    min-height: 350px;
  }

  .item-image {
    height: 180px;
  }

  .item-content {
    padding: 25px;
  }

  .header-content {
    flex-direction: column;
    gap: 25px;
    text-align: center;
    padding: 25px 20px;
  }

  .header-text::before {
    display: none;
  }

  .header-text h2 {
    font-size: 2.5rem;
  }

  .header-text h2::after {
    left: 50%;
    transform: translateX(-50%);
  }

  .view-all-btn {
    padding: 12px 24px;
    font-size: 0.95rem;
  }

  .medicine-item {
    flex-direction: column;
    min-height: auto;
  }

  .item-image {
    width: 100%;
    height: 200px;
  }

  .item-header {
    flex-direction: column;
    gap: 10px;
    align-items: flex-start;
  }

  .item-title {
    margin-right: 0;
  }

  .detail-row {
    flex-direction: column;
    gap: 4px;
  }

  .detail-label {
    min-width: auto;
    margin-right: 0;
  }
}

/* 震撼关于我们区域 - 现代化设计 */
.about-section {
  background: linear-gradient(135deg,
    #0f0f23 0%,
    #1a1a3e 25%,
    #2d1b69 50%,
    #1a1a3e 75%,
    #0f0f23 100%);
  background-size: 400% 400%;
  animation: aboutGradient 15s ease infinite;
  padding: 150px 0;
  position: relative;
  overflow: hidden;
  min-height: 100vh;
}

.about-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(circle at 20% 80%, rgba(59, 130, 246, 0.15) 0%, transparent 50%),
              radial-gradient(circle at 80% 20%, rgba(139, 92, 246, 0.15) 0%, transparent 50%),
              radial-gradient(circle at 40% 40%, rgba(236, 72, 153, 0.1) 0%, transparent 50%);
  animation: pulseGlow 10s ease-in-out infinite;
}

.about-section::after {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: conic-gradient(from 0deg, transparent, rgba(59, 130, 246, 0.05), transparent, rgba(139, 92, 246, 0.05), transparent);
  animation: rotate 25s linear infinite;
  pointer-events: none;
}

.about-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
  position: relative;
  z-index: 10;
}

.about-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}

.about-content-area {
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(30px);
  -webkit-backdrop-filter: blur(30px);
  border-radius: 35px;
  padding: 80px 60px;
  box-shadow: 0 40px 120px rgba(0, 0, 0, 0.3),
              0 0 0 1px rgba(255, 255, 255, 0.4),
              inset 0 1px 0 rgba(255, 255, 255, 0.6);
  border: 2px solid rgba(255, 255, 255, 0.3);
  width: 100%;
  max-width: 1000px;
  position: relative;
  overflow: hidden;
  animation: aboutCardFloat 8s ease-in-out infinite;
}

.about-content-area::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg,
    rgba(59, 130, 246, 0.02) 0%,
    rgba(139, 92, 246, 0.04) 25%,
    rgba(236, 72, 153, 0.02) 50%,
    rgba(251, 191, 36, 0.04) 75%,
    rgba(34, 197, 94, 0.02) 100%);
  pointer-events: none;
}

.about-content-area::after {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: conic-gradient(from 0deg, transparent, rgba(59, 130, 246, 0.01), transparent);
  animation: rotate 20s linear infinite;
  pointer-events: none;
}

.content-header {
  margin-bottom: 60px;
  text-align: center;
  position: relative;
  z-index: 2;
}

.header-badge {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  background: linear-gradient(135deg, #3b82f6, #8b5cf6, #ec4899);
  background-size: 200% 200%;
  color: white;
  padding: 12px 24px;
  border-radius: 25px;
  font-size: 1rem;
  font-weight: 700;
  margin-bottom: 30px;
  animation: gradientText 4s ease-in-out infinite;
  box-shadow: 0 8px 25px rgba(59, 130, 246, 0.4);
  border: 1px solid rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  text-transform: uppercase;
  letter-spacing: 1px;
}

.main-title {
  font-size: 3.5rem;
  font-weight: 900;
  margin-bottom: 20px;
  line-height: 1.1;
  background: linear-gradient(135deg,
    #3b82f6 0%,
    #8b5cf6 25%,
    #ec4899 50%,
    #f59e0b 75%,
    #10b981 100%);
  background-size: 200% 200%;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  animation: gradientText 5s ease-in-out infinite;
  text-shadow: 0 0 40px rgba(59, 130, 246, 0.3);
  letter-spacing: -0.02em;
  position: relative;
}

.main-title::after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 100px;
  height: 4px;
  background: linear-gradient(90deg, #3b82f6, #8b5cf6, #ec4899);
  border-radius: 2px;
  animation: gradientText 3s ease-in-out infinite;
}

.subtitle {
  font-size: 1.4rem;
  color: #64748b;
  line-height: 1.6;
  margin: 0;
  font-weight: 500;
  opacity: 0.9;
}

.content-body {
  display: flex;
  flex-direction: column;
  gap: 40px;
}

.description-text {
  font-size: 1.1rem;
  line-height: 1.8;
  color: #475569;
}

.description-text p {
  margin-bottom: 20px;
}

.highlight-features {
  display: flex;
  gap: 40px;
  padding: 40px;
  background: linear-gradient(135deg,
    rgba(59, 130, 246, 0.08) 0%,
    rgba(139, 92, 246, 0.1) 25%,
    rgba(236, 72, 153, 0.08) 50%,
    rgba(251, 191, 36, 0.1) 75%,
    rgba(34, 197, 94, 0.08) 100%);
  background-size: 200% 200%;
  animation: gradientText 6s ease-in-out infinite;
  border-radius: 25px;
  border: 2px solid rgba(59, 130, 246, 0.2);
  box-shadow: 0 20px 40px rgba(59, 130, 246, 0.1);
  position: relative;
  overflow: hidden;
}

.highlight-features::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(45deg,
    rgba(255, 255, 255, 0.1) 0%,
    transparent 50%,
    rgba(255, 255, 255, 0.1) 100%);
  pointer-events: none;
}

.feature-item {
  text-align: center;
  flex: 1;
  position: relative;
  z-index: 2;
  padding: 20px;
  border-radius: 20px;
  transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1);
}

.feature-item:hover {
  transform: translateY(-10px) scale(1.05);
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
}

.feature-number {
  font-size: 3.5rem;
  font-weight: 900;
  background: linear-gradient(135deg,
    #3b82f6 0%,
    #8b5cf6 50%,
    #ec4899 100%);
  background-size: 200% 200%;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  margin-bottom: 12px;
  animation: gradientText 4s ease-in-out infinite;
  text-shadow: 0 0 30px rgba(59, 130, 246, 0.3);
  line-height: 1;
}

.feature-label {
  font-size: 1.1rem;
  color: #475569;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.core-values {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  margin: 50px 0;
}

.value-card {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  padding: 35px 25px;
  border-radius: 25px;
  text-align: center;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15),
              0 0 0 1px rgba(255, 255, 255, 0.3),
              inset 0 1px 0 rgba(255, 255, 255, 0.4);
  transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1);
  border: 2px solid rgba(255, 255, 255, 0.3);
  position: relative;
  overflow: hidden;
}

.value-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg,
    rgba(59, 130, 246, 0.02) 0%,
    rgba(139, 92, 246, 0.04) 50%,
    rgba(236, 72, 153, 0.02) 100%);
  opacity: 0;
  transition: opacity 0.6s ease;
  pointer-events: none;
}

.value-card:hover {
  transform: translateY(-15px) rotateY(5deg) scale(1.05);
  box-shadow: 0 40px 100px rgba(59, 130, 246, 0.25);
}

.value-card:hover::before {
  opacity: 1;
}

.value-icon {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #3b82f6, #8b5cf6, #ec4899);
  background-size: 200% 200%;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 25px;
  color: white;
  animation: gradientText 4s ease-in-out infinite;
  box-shadow: 0 15px 35px rgba(59, 130, 246, 0.3);
  position: relative;
  z-index: 2;
  transition: all 0.6s ease;
}

.value-card:hover .value-icon {
  transform: scale(1.1) rotateY(180deg);
  box-shadow: 0 25px 50px rgba(59, 130, 246, 0.5);
}

.value-card h4 {
  font-size: 1.4rem;
  font-weight: 800;
  background: linear-gradient(135deg, #2d3748 0%, #3b82f6 100%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  margin-bottom: 15px;
  position: relative;
  z-index: 2;
}

.value-card p {
  color: #64748b;
  font-size: 1rem;
  margin: 0;
  line-height: 1.6;
  position: relative;
  z-index: 2;
}

.action-area {
  display: flex;
  justify-content: center;
  margin-top: 50px;
}

.learn-more-btn {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  background: linear-gradient(135deg, #3b82f6, #8b5cf6, #ec4899);
  background-size: 200% 200%;
  color: white;
  padding: 18px 40px;
  border-radius: 35px;
  text-decoration: none;
  font-weight: 700;
  font-size: 1.2rem;
  transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1);
  box-shadow: 0 15px 40px rgba(59, 130, 246, 0.4);
  border: 2px solid rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  position: relative;
  overflow: hidden;
  animation: gradientText 4s ease-in-out infinite;
}

.learn-more-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
  transition: left 0.6s ease;
}

.learn-more-btn:hover::before {
  left: 100%;
}

.learn-more-btn:hover {
  transform: translateY(-5px) scale(1.05);
  box-shadow: 0 25px 60px rgba(59, 130, 246, 0.6);
  border-color: rgba(255, 255, 255, 0.4);
}

.learn-more-btn svg {
  transition: transform 0.6s ease;
}

.learn-more-btn:hover svg {
  transform: translateX(6px) rotate(45deg);
}



/* 关于我们响应式设计 */
@media (max-width: 1024px) {
  .about-content-area {
    padding: 50px 40px;
    max-width: 800px;
  }

  .main-title {
    font-size: 2.2rem;
  }

  .highlight-features {
    flex-direction: column;
    gap: 20px;
  }

  .core-values {
    grid-template-columns: 1fr;
    gap: 15px;
  }
}

@media (max-width: 768px) {
  .about-section {
    padding: 80px 0;
  }

  .about-container {
    padding: 0 15px;
  }

  .about-content-area {
    padding: 40px 25px;
    max-width: 100%;
  }

  .main-title {
    font-size: 2.5rem;
  }

  .subtitle {
    font-size: 1.2rem;
  }

  .content-body {
    gap: 40px;
  }

  .highlight-features {
    flex-direction: column;
    gap: 25px;
    padding: 30px 25px;
  }

  .feature-number {
    font-size: 3rem;
  }

  .core-values {
    grid-template-columns: 1fr;
    gap: 25px;
  }

  .value-card {
    padding: 30px 25px;
  }

  .value-icon {
    width: 70px;
    height: 70px;
  }
}

@media (max-width: 480px) {
  .about-content-area {
    padding: 30px 20px;
  }

  .main-title {
    font-size: 1.7rem;
  }

  .header-badge {
    padding: 6px 16px;
    font-size: 0.85rem;
  }

  .highlight-features {
    padding: 20px 15px;
  }

  .feature-number {
    font-size: 1.8rem;
  }

  .core-values {
    gap: 12px;
  }

  .value-card {
    padding: 20px;
  }
}




/* 媒体查询，响应式设计 */
@media (max-width: 1200px) {
  .product-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}

@media (max-width: 992px) {
  .about-content {
    flex-direction: column;
  }
}

/* 加载中和错误样式 */
.loading-wrapper,
.error-wrapper {
  height: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #909399;
  margin-top: 80px;
  gap: 10px;
}

.loading-icon {
  animation: rotating 2s linear infinite;
}

@keyframes rotating {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.banner-link {
  display: block;
  height: 100%;
  width: 100%;
  text-decoration: none;
}

.quick-view-btn {
  background-color: white;
  color: #333;
  border: none;
  padding: 10px 15px;
  border-radius: 25px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  font-size: 0.9rem;
}

.quick-view-btn:hover {
  background-color: #3a8ee6;
  color: white;
}

.detail-view-btn {
  background-color: white;
  color: #333;
  border: none;
  padding: 10px 15px;
  border-radius: 25px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  font-size: 0.9rem;
  text-decoration: none;
}

.detail-view-btn:hover {
  background-color: #3a8ee6;
  color: white;
}



.about-us:before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 5px;
  background: linear-gradient(90deg, #3a8ee6, #42b983);
}

.image-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(0deg, rgba(58, 142, 230, 0.9) 0%, rgba(58, 142, 230, 0) 100%);
  padding: 30px 20px 15px;
  color: white;
}

.overlay-content {
  font-size: 1.2rem;
  font-weight: 600;
  text-align: center;
}

/* 添加加载和错误状态样式 */
.loading-container,
.error-container,
.empty-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 300px;
  margin: 50px 0;
}

.loading-icon,
.error-icon {
  font-size: 48px;
  margin-bottom: 20px;
}

.loading-icon {
  color: #3a8ee6;
  animation: rotate 2s linear infinite;
}

.error-icon {
  color: #f56c6c;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.retry-btn {
  margin-top: 20px;
  background-color: #3a8ee6;
  color: white;
  border: none;
  padding: 10px 25px;
  border-radius: 25px;
  cursor: pointer;
  transition: all 0.3s;
  font-weight: 600;
}

.retry-btn:hover {
  background-color: #2c6eb9;
  transform: translateY(-3px);
}

.pagination-container {
  margin-top: 50px;
  display: flex;
  justify-content: center;
}

/* 粒子爆炸和波浪扭曲动画 */
@keyframes particleExplode {
  0% {
    transform: translate(-50%, -50%) scale(0) rotate(0deg);
    opacity: 0;
    background: radial-gradient(circle, #60a5fa 0%, #3b82f6 30%, transparent 70%);
  }
  25% {
    transform: translate(-50%, -50%) scale(10) rotate(90deg);
    opacity: 0.8;
    background: radial-gradient(circle, #8b5cf6 0%, #7c3aed 30%, transparent 70%);
  }
  50% {
    transform: translate(-50%, -50%) scale(25) rotate(180deg);
    opacity: 1;
    background: radial-gradient(circle, #ec4899 0%, #db2777 30%, transparent 70%);
  }
  75% {
    transform: translate(-50%, -50%) scale(40) rotate(270deg);
    opacity: 0.6;
    background: radial-gradient(circle, #fbbf24 0%, #f59e0b 30%, transparent 70%);
  }
  100% {
    transform: translate(-50%, -50%) scale(60) rotate(360deg);
    opacity: 0;
    background: radial-gradient(circle, #22c55e 0%, #16a34a 30%, transparent 70%);
  }
}

@keyframes waveDistortion {
  0% {
    clip-path: polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%);
    filter: hue-rotate(0deg) saturate(1) brightness(1);
  }
  20% {
    clip-path: polygon(0% 10%, 100% 0%, 100% 90%, 0% 100%);
    filter: hue-rotate(72deg) saturate(1.2) brightness(1.1);
  }
  40% {
    clip-path: polygon(0% 20%, 100% 10%, 100% 80%, 0% 90%);
    filter: hue-rotate(144deg) saturate(1.4) brightness(1.2);
  }
  60% {
    clip-path: polygon(0% 30%, 100% 20%, 100% 70%, 0% 80%);
    filter: hue-rotate(216deg) saturate(1.6) brightness(1.3);
  }
  80% {
    clip-path: polygon(0% 40%, 100% 30%, 100% 60%, 0% 70%);
    filter: hue-rotate(288deg) saturate(1.8) brightness(1.4);
  }
  100% {
    clip-path: polygon(0% 50%, 100% 50%, 100% 50%, 0% 50%);
    filter: hue-rotate(360deg) saturate(2) brightness(1.5);
  }
}

@keyframes waveDistortionReverse {
  0% {
    clip-path: polygon(0% 50%, 100% 50%, 100% 50%, 0% 50%);
    filter: hue-rotate(360deg) saturate(2) brightness(1.5);
  }
  20% {
    clip-path: polygon(0% 40%, 100% 30%, 100% 60%, 0% 70%);
    filter: hue-rotate(288deg) saturate(1.8) brightness(1.4);
  }
  40% {
    clip-path: polygon(0% 30%, 100% 20%, 100% 70%, 0% 80%);
    filter: hue-rotate(216deg) saturate(1.6) brightness(1.3);
  }
  60% {
    clip-path: polygon(0% 20%, 100% 10%, 100% 80%, 0% 90%);
    filter: hue-rotate(144deg) saturate(1.4) brightness(1.2);
  }
  80% {
    clip-path: polygon(0% 10%, 100% 0%, 100% 90%, 0% 100%);
    filter: hue-rotate(72deg) saturate(1.2) brightness(1.1);
  }
  100% {
    clip-path: polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%);
    filter: hue-rotate(0deg) saturate(1) brightness(1);
  }
}

/* 3D透视效果增强 */
.fragment-carousel {
  perspective: 2000px;
  transform-style: preserve-3d;
}

.fragment-carousel-item {
  transform-style: preserve-3d;
  backface-visibility: hidden;
}

/* 更多随机位移变量 */
.fragment:nth-child(26) { --random-x: -200px; --random-y: -100px; }
.fragment:nth-child(27) { --random-x: -100px; --random-y: -150px; }
.fragment:nth-child(28) { --random-x: 50px; --random-y: -200px; }
.fragment:nth-child(29) { --random-x: 200px; --random-y: -150px; }
.fragment:nth-child(30) { --random-x: 350px; --random-y: -100px; }
.fragment:nth-child(31) { --random-x: -350px; --random-y: 50px; }
.fragment:nth-child(32) { --random-x: -200px; --random-y: 100px; }
.fragment:nth-child(33) { --random-x: -50px; --random-y: 150px; }
.fragment:nth-child(34) { --random-x: 100px; --random-y: 200px; }
.fragment:nth-child(35) { --random-x: 300px; --random-y: 150px; }
.fragment:nth-child(36) { --random-x: -400px; --random-y: 200px; }
.fragment:nth-child(37) { --random-x: -250px; --random-y: 300px; }
.fragment:nth-child(38) { --random-x: 0px; --random-y: 350px; }
.fragment:nth-child(39) { --random-x: 250px; --random-y: 300px; }
.fragment:nth-child(40) { --random-x: 400px; --random-y: 200px; }
.fragment:nth-child(41) { --random-x: -300px; --random-y: -300px; }
.fragment:nth-child(42) { --random-x: -150px; --random-y: -350px; }
.fragment:nth-child(43) { --random-x: 0px; --random-y: -400px; }
.fragment:nth-child(44) { --random-x: 150px; --random-y: -350px; }
.fragment:nth-child(45) { --random-x: 300px; --random-y: -300px; }
.fragment:nth-child(46) { --random-x: -450px; --random-y: 0px; }
.fragment:nth-child(47) { --random-x: -300px; --random-y: 50px; }
.fragment:nth-child(48) { --random-x: -150px; --random-y: 100px; }
.qualification{
  width: 100%;
  margin-top: 24px;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;
  margin-bottom: 20px;
  position: relative;
}

.qualification-item{
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
  background: #fff;
}

.qualification-item .el-image{
  width: 100%;
  max-height: 450px;
  display: block;
}
</style>
